import { Box, Button, Container, IconButton, Typography } from "@mui/material";
import { AnimatedBackground } from "components/AnimatedBackground";
import Iconify from "components/iconify";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import { useEffect, useState } from "react";
import { DISCORD, TELEGRAM, TIKTOK, TWITTER } from "utils/constants";
import { uuidBs58 } from "utils/solana/uuid";

// import * as anchor from "@coral-xyz/anchor";

import { PublicKey } from "@solana/web3.js";
import { useBoolean } from "../../../hooks/useBoolean";

import { useWallet } from "@solana/wallet-adapter-react";
import { WalletDisconnectButton, WalletMultiButton } from "@solana/wallet-adapter-react-ui";
import BN from "bn.js";
import LoadingOverlay from "components/LoadingOverlay";
import { useFartlabProgram } from "hooks/useFartlabProgram";
import { callSupabaseFartSubmission } from "utils/anchor/oracleConnector";
import { canUserSubmitToChampionship, fetchLatestChampionship } from "utils/solana/championship";
import { fetchSubmissionsWithVotes } from "utils/solana/submission";
import { transferSplToken } from "utils/solanaTransfers";
import CartoonDialog from "../../../components/CartoonDialog/CartoonDialog";


// Default styles that can be overridden by your app
require('@solana/wallet-adapter-react-ui/styles.css');


// Social Media Links with Different Background & Hover Colors
const SOCIALS = [
  {
    name: "X (Twitter)",
    icon: "hugeicons:new-twitter-ellipse", // X icon
    url: TWITTER,
    bgColor: "#1DA1F2", // Twitter Blue
    hoverColor: "#0D8DD9", // Darker Twitter Blue
  },
  {
    name: "TikTok",
    icon: "hugeicons:tiktok",
    url: TIKTOK,
    bgColor: "#FF0050", // TikTok Red
    hoverColor: "#D40042", // Darker TikTok Red
  },
  {
    name: "Discord",
    icon: "hugeicons:discord",
    url: DISCORD,
    bgColor: "#404EED", // Discord Blue
    hoverColor: "#5865F2", // Discord Darker Blue
  },
  {
    name: "Telegram",
    icon: "hugeicons:telegram",
    url: TELEGRAM,
    bgColor: "#0088CC", // Telegram Blue
    hoverColor: "#1C92D2", // Lighter Telegram Blue
  }
];


function ComingSoon() {
  const [dots, setDots] = useState("");
  // const { walletAddress, connectWallet, disconnectWallet, phantomProvider, transferTokens } =
  //   usePhantom();
    // const { transferTokens } = usePhantom();
  const alertDialog = useBoolean();
  const [dialogTitle, setDialogTitle] = useState("");
  const [dialogDescription, setDialogDescription] = useState("");

  const { publicKey: walletAddress, connected, sendTransaction, signTransaction } = useWallet();
  const { program, provider, wallet, connection } = useFartlabProgram();
  const [loading, setLoading] = useState(false);

  // Animate the loading dots
  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev.length < 3 ? prev + "." : ""));
    }, 500);
    return () => clearInterval(interval);
  }, []);

  const handleFartSubmission = async () => {
    setLoading(true);
    // console.log("wallets" + JSON.stringify(wallets));
    if (!connected || !walletAddress) {
      setLoading(false);
      return;
    }

    // const response = await wallet.connect();
    // console.log("✅ Connected:", response.publicKey.toBase58());
    const championship = await fetchLatestChampionship(program, provider);
    if (!championship) {
      setDialogTitle("No Championships Found");
      setDialogDescription("No active championships available. Please check back later.");
      alertDialog.onTrue();
      console.error("❌ No Championships found!");
      setLoading(false);
      return;
    }
    const championshipUuid = championship.uuid;
    console.log("🏆 Latest Championships:", championship);
    console.log("🏆 Championship UUID:", championshipUuid);

    const championshipSubmissionsWithVotes = await fetchSubmissionsWithVotes(program, provider, championshipUuid, wallet.publicKey);
    console.log("🏆 Championship Submissions with Votes:", championshipSubmissionsWithVotes);

    const currentTime = new BN(Math.floor(Date.now() / 1000));
    const canUserSubmit = await canUserSubmitToChampionship(
      program,
      provider,
      championshipUuid,
      wallet.publicKey,
      currentTime
    );
    console.log("⏰ Can User Submit:", canUserSubmit);
    if (!canUserSubmit) {
      setDialogTitle("Submission Not Allowed");
      setDialogDescription("You cannot submit to this championship. Please check the rules.");
      alertDialog.onTrue();
      return;
    }

    // const championshipRead = await getChampionship(program, championshipUUId);
    // console.log("🏆 Championship Read:", championshipRead);

    const amount = BigInt(10);
    // const submissionPrice = await getFartSubmissionPrice();

    console.log("💰 Submission Price:", amount);


    const rewardsPool = new PublicKey(process.env.REACT_APP_REWARDS_POOL);
    const mintAddress = new PublicKey(process.env.REACT_APP_TOKEN_MINT);

    const transferResult = await transferSplToken({
      senderPublicKey: walletAddress,
      recipientAta: rewardsPool,
      mintPublicKey: mintAddress,
      amount,
      connection,
      sendTransaction,
      signTransaction,
    });

    // const transferResult = await transferTokens(
    //   rewardsPool, // The program's rewards pool address
    //   mintAddress, // The SPL token mint address
    //   submissionPrice, // Submission fee amount
    //   program,
    //   provider
    // );
    if (transferResult.error) {
      setDialogTitle(transferResult.error);
      setDialogDescription(transferResult.errorDescription);
      alertDialog.onTrue();
      setLoading(false);
      return;
    }
    console.log("💸 Transfer Result:", transferResult);
    const txId = transferResult.txId;
    setDialogTitle("Payment Successful!");
    setDialogDescription("Your payment has been processed. Now you can submit your fart!");
    alertDialog.onTrue();
    setLoading(false);
    return;
    // const txId = "N69zASw1gZcCMXTK3xHKMef5TTnobthWbxw1AN4PYQvpxmwE5xMX63dd4NZmmcHGCuf51T2FDbQpDoPXXsaJwm7";
    const fartUuid = uuidBs58(); // Unique fart ID
    const fartData = {
      uuid: fartUuid,
      title: "The Loudest Boom",
      description: "An earth-shaking fart heard across the galaxy!",
      championshipUuid,
    };

    const fartSubmissionResult = await callSupabaseFartSubmission(txId, wallet.publicKey, fartData);

    // const fartSubmissionResult = await registerFartSubmission(
    //   txId,
    //   new PublicKey(walletAddress),
    //   fartData
    // );
    if (fartSubmissionResult.success) {
      setDialogTitle("Fart submitted!");
      setDialogDescription(
        "Your fart has been submitted to the championship. May the farts be with you!"
      );
      alertDialog.onTrue();
      return;
    }
    console.log("🚀 Fart Submission Result:", fartSubmissionResult);

    // const initialCount = await getChampionshipCount(program, provider);
    // console.log(`🏆 Initial Championship Count: ${initialCount}`);
    // try {
    // const connection = new web3.Connection("http://127.0.0.1:8899", "processed");
    // const provider = new AnchorProvider(connection, window.solana, {
    //   preflightCommitment: "processed",
    // });
    // const program = new Program(idl, PROGRAM_ID, provider);

    // const provider = anchor.AnchorProvider.env();
    // anchor.setProvider(provider);

    // const program = anchor.workspace.Fartlab;
    // const admin = provider.wallet.publicKey;
    // const wallet = provider.wallet;
    // const state = anchor.web3.Keypair.generate();

    // const admin = provider.wallet.publicKey;
    // const wallet = provider.wallet;
    // const state = anchor.web3.Keypair.generate();
    // const initialCount = await getChampionshipCount(program, provider);
    // console.log(`🏆 Initial Championship Count: ${initialCount}`);
    return;
    // const uuid = uuidBs58();;
    // const championshipUuid = "some-existing-championship-uuid"; // Replace with real UUID
    // const fartUuid = uuidBs58(); // ✅ Generate a unique fart UUID
    // const title = "Epic Fart!";
    // const description = "This fart is legendary!";
    // const submittedAt = Math.floor(Date.now() / 1000);
    // const paymentTx = new PublicKey("11111111111111111111111111111111"); // Fake TX, replace when integrating payments

    // console.log(`🚀 Submitting Fart from Wallet: ${walletAddress}`);
    // const tx = await createFartSubmission(
    //   walletAddress,
    //   uuid,
    //   championshipUuid,
    //   fartUuid,
    //   title,
    //   description,
    //   submittedAt,
    //   paymentTx
    // );
    // console.log(`✅ Fart Submitted! TX: ${tx}`);
    // } catch (error) {
    //   console.error("❌ Fart submission failed:", error);
    // }
  };

  return (
    <>
      {/* Navbar */}
      <DefaultNavbar routes={[]} transparent light />

      {/* Animated Background */}
      <AnimatedBackground useTimeBased={true} timeDuration={5}>
        <Container
          sx={{
            minHeight: "95vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          {/* Teasing Title */}
          <Typography
            variant="h2"
            sx={{
              fontWeight: "bold",
              color: "#FFD700",
              textShadow: "4px 4px 0px rgba(0,0,0,0.4)",
              mt: { xs: 20, md: 18, lg: 10 },
              mb: { xs: 4, md: 5, lg: 6 },
            }}
          >
            Something Big is Coming{dots}
          </Typography>

          {/* Mysterious Message */}
          <Typography
            variant="h4"
            color="white !important"
            sx={{
              maxWidth: "600px",
              opacity: 0.9,
              mb: 4,
            }}
          >
            {"We can’t reveal too much just yet... 👀"}
            <br />
            {"But our AI-powered app is nearly here"}
            <br />
            <strong>
              {"Expect wild surprises, gamified challenges, and a next-gen experience! 🚀"}
            </strong>
            <br />
            <br />
            {"Stay tuned. The future is about to get way more interesting. 💨"}
          </Typography>

          {/* 🚨 No Token Disclaimer */}
          <Typography
            variant="h6"
            sx={{
              maxWidth: "500px",
              color: "#FF4E50",
              fontWeight: "bold",
              textShadow: "3px 3px 0px rgba(0,0,0,0.3)",
              border: "2px dashed #FFD700",
              padding: "12px 16px",
              borderRadius: "12px",
              backgroundColor: "rgba(0,0,0,0.5)",
              mb: 4,
              "&:hover": {
                transform: "scale(1.3)",
                transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
              },
            }}
          >
            ❌ No Token Yet! Beware of Scams.
            <br />
            If it’s not from us, it’s not real.
          </Typography>

          {/* 🔗 Phantom Wallet Button (Reusable) */}
          <Box sx={{ display: "flex", gap: 3, mt: 4 }}>
            {/* <PhantomButton
            // walletAddress={walletAddress}
            // connectWallet={connectWallet}
            // disconnectWallet={disconnectWallet}
            // phantomProvider={phantomProvider}
            /> */}
            <Button
              variant="contained"
              onClick={handleFartSubmission}
              disabled={!walletAddress}
              sx={{
                backgroundColor: walletAddress ? "#22C55E" : "#666",
                color: "white",
                fontWeight: "bold",
                textTransform: "none",
                borderRadius: "12px",
                "&:hover": { backgroundColor: walletAddress ? "#16A34A" : "#666" },
              }}
            >
              Submit Fart 💨
            </Button>
            <WalletMultiButton />
            <WalletDisconnectButton />
          </Box>

          {/* Social Buttons */}
          <Box sx={{ display: "flex", gap: 3, mt: 4 }}>
            {SOCIALS.map((social) => (
              <IconButton
                key={social.name}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  fontSize: 32,
                  width: 60,
                  height: 60,
                  color: "white",
                  backgroundColor: social.bgColor, // Different BG color per button
                  borderRadius: "50%",
                  border: "3px solid black",
                  boxShadow: "5px 5px 0px rgba(0,0,0,0.4)",
                  transition: "0.3s ease-in-out",

                  "&:hover": {
                    backgroundColor: social.hoverColor, // Different hover effect
                    transform: "rotate(15deg) scale(1.1)",
                    transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
                  },
                }}
              >
                <Iconify icon={social.icon} width={32} height={32} />
              </IconButton>
            ))}
          </Box>

          {/* Fun Icon */}
          <Box mt={4}>
            <Iconify
              icon="mdi:weather-windy"
              width={60}
              height={60}
              color="white"
              sx={{
                "&:hover": {
                  transform: "rotate(15deg) scale(1.1)",
                  transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
                },
              }}
            />
          </Box>
        </Container>
        <CartoonDialog
          open={alertDialog.value}
          onClose={alertDialog.onFalse}
          title={dialogTitle}
          description={dialogDescription}
        />
        {/* Footer */}
        {/* <CenteredFooter light /> */}
        <LoadingOverlay show={loading} />
      </AnimatedBackground>
    </>
  );
}

export default ComingSoon;
